// extracted by mini-css-extract-plugin
export default {"warningIconTriangle":"WarningText_warningIconTriangle__y32xx","warningText":"WarningText_warningText__9MmbP","notBold":"WarningText_notBold__HmTE1"};